import { Component, EventEmitter, Injector, OnInit, Output, ViewChild } from '@angular/core';
import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { TIMEOUT_FOR_MIMICING_STOP_PROPAGATION } from '../../../../constants/timing.constants';
import { BaseComponent } from '../../../shared/components/base/base.component';
@Component({
	standalone: true,
	selector: 'logout-modal',
	templateUrl: './logout.component.html'
})
export class LogoutComponent extends BaseComponent implements OnInit {
	@ViewChild('logoutModalContent', { static: true }) logoutModalContent;
	@Output() logoutEmitter = new EventEmitter<boolean>(false);
	@Output() userActivityEmiter = new EventEmitter<boolean>(false);

	isLogout = false;
	isShowUserActivity = false;
	constructor(injector: Injector) {
		super(injector);
	}

	ngOnInit(): void {
		this.openModalWithDelay();
	}

	openModalWithDelay() {
		setTimeout(() => {
			// 10 ms delay to mimic 'stop-propagation'
			this.openModal();
		}, TIMEOUT_FOR_MIMICING_STOP_PROPAGATION);
	}

	openModal() {
		const ngbModalOptions: NgbModalOptions = {
			backdrop: 'static',
			keyboard: false
		};
		const modalInstance = this.modalService.open(this.logoutModalContent, ngbModalOptions);
		modalInstance.result.then(
			() => {
				// a promised that is resolved when the modal is closed
				// Get triggers when modal is closed
			},
			() => {
				this.doAfterCloseOperations(); // Gets triggers when modal is dismissed.
			}
		);
	}
	doAfterCloseOperations() {
		if (this.isShowUserActivity) this.userActivityEmiter.emit(this.isShowUserActivity);
		else this.logoutEmitter.emit(this.isLogout);
	}
	onCloseModal(event: boolean) {
		this.isLogout = event;
		this.modalService.dismissAll();
	}
	// onShowUserActivityClick() {
	//   this.isShowUserActivity = true;
	//   this.modalService.dismissAll();
	// }
}
